(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const progress = document.querySelector('[data-scroll-progress]');
  const stories = [...document.querySelectorAll('[data-product-story]')];
  const activeStories = new Set();
  let pending = false;
  const update = () => {
    pending = false;
    if (motion.matches) return;
    if (progress) {
      const range = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.transform = `scaleX(${range > 0 ? window.scrollY / range : 0})`;
    }
    activeStories.forEach((story) => {
      const rect = story.getBoundingClientRect();
      const amount = Math.min(1, Math.max(0, (window.innerHeight * .75 - rect.top) / (rect.height - window.innerHeight * .25)));
      const bar = story.querySelector('[data-story-progress]');
      if (bar) bar.style.transform = `scaleX(${amount})`;
      const steps = [...story.querySelectorAll('[data-story-step]')];
      let nearest = null;
      let distance = Infinity;
      steps.forEach((step) => {
        const bounds = step.getBoundingClientRect();
        if (bounds.top < window.innerHeight * .92) step.classList.add('is-seen');
        const d = Math.abs(bounds.top + bounds.height / 2 - window.innerHeight / 2);
        if (d < distance) { distance = d; nearest = step; }
      });
      steps.forEach((step) => step.classList.toggle('is-current', step === nearest));
    });
  };
  const queue = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  const storyObserver = new IntersectionObserver((entries) => {
    entries.forEach(({target,isIntersecting}) => { if (isIntersecting) activeStories.add(target); else activeStories.delete(target); });
    queue();
  }, {rootMargin: '100px'});
  stories.forEach((story) => { if (!motion.matches) story.dataset.motionReady = 'true'; storyObserver.observe(story); });
  const reveals = [...document.querySelectorAll('.product-card,.why-section__item,.process-steps__step,.about-studio__text,.newsletter__inner,.custom-callout__inner,.collection-card,.buyer-guides__card')];
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(({target,isIntersecting}) => { if (isIntersecting) { target.classList.add('is-in'); revealObserver.unobserve(target); } });
  }, {threshold: .08,rootMargin:'0px 0px 20px 0px'});
  reveals.forEach((el,i) => {
    if (motion.matches) return;
    el.classList.add('reveal');
    el.style.transitionDelay = `${Math.min(i % 4, 3) * 35}ms`;
    if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    else revealObserver.observe(el);
  });
  document.addEventListener('scroll', queue, {passive:true});
  window.addEventListener('resize', queue, {passive:true});
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    new MutationObserver(() => { if (motion.matches) return; el.classList.remove('pop'); requestAnimationFrame(() => el.classList.add('pop')); }).observe(el,{childList:true,characterData:true,subtree:true});
  });
  const hydrate = (video) => {
    video.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; source.removeAttribute('data-src'); });
    if (!video.dataset.mediaReady) { video.dataset.mediaReady = 'true'; video.load(); }
  };
  const models = [...document.querySelectorAll('[data-product-model][auto-rotate]')];
  const visibleModels = new Set();
  const syncModels = () => models.forEach((model) => model.toggleAttribute('auto-rotate', !motion.matches && !document.hidden && visibleModels.has(model)));
  const modelObserver = new IntersectionObserver((entries) => {
    entries.forEach(({target,isIntersecting}) => { if (isIntersecting) visibleModels.add(target); else visibleModels.delete(target); });
    syncModels();
  });
  models.forEach((model) => modelObserver.observe(model));
  syncModels();
  const videos = [...document.querySelectorAll('video')];
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach(({target,isIntersecting}) => { if (!isIntersecting) target.pause(); });
  });
  videos.forEach((video) => {
    videoObserver.observe(video);
    if (video.querySelector('source[data-src]')) video.addEventListener('pointerdown',() => hydrate(video),{once:true});
    const toggle = video.closest('.story-step__media')?.querySelector('[data-video-toggle]');
    if (toggle) {
      const sync = () => { toggle.textContent = video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel; };
      toggle.addEventListener('click', () => { hydrate(video); if (video.paused) video.play().catch(sync); else video.pause(); });
      video.addEventListener('play',sync); video.addEventListener('pause',sync); sync();
    }
    const card = video.closest('.product-card');
    if (card) {
      const play = () => { if (motion.matches || navigator.connection?.saveData) return; hydrate(video); video.play().catch(() => {}); };
      card.addEventListener('pointerenter',(event) => { if (event.pointerType === 'mouse') play(); });
      card.addEventListener('pointerleave',() => video.pause());
      card.addEventListener('focusin',play);
      card.addEventListener('focusout',() => video.pause());
    }
  });
  document.addEventListener('visibilitychange',() => { if (document.hidden) videos.forEach((video) => video.pause()); syncModels(); });
  motion.addEventListener('change',() => {
    syncModels();
    if (motion.matches) {
      reveals.forEach((el) => el.classList.add('is-in'));
      stories.forEach((story) => delete story.dataset.motionReady);
      videos.forEach((video) => video.pause());
    } else stories.forEach((story) => { story.dataset.motionReady = 'true'; });
    queue();
  });
  queue();
})();
